import React from "react";

var FavoriteHalfIcon = function FavoriteHalfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.651.888L7.83 6.961a.056.056 0 0 1-.041.032L1.142 8.021C.048 8.19-.388 9.617.404 10.435l4.812 4.974a.061.061 0 0 1 .016.052l-1.075 6.674c-.21 1.301 1.077 2.292 2.177 1.677l5.645-3.154c.006-.004.013.001.02 0V0c-.535-.001-1.073.294-1.348.888z"
  }));
};

FavoriteHalfIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
FavoriteHalfIcon.defaultProps.solid = true;
export default FavoriteHalfIcon;